import {useTheme} from '@mui/material/styles';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {ctxSplitScreen} from '../../../../store/reducers/patientContext';

const RowContainer = (props) => {
    const theme = useTheme();
    const [widthElement, setWidthElement] = useState('calc(100vw - 110px)');
    const splitScreen = useSelector(ctxSplitScreen);

    const getWidth = () => {
        const attListItem = document.getElementById('attendance-list-item');
        const timelineEle = document.getElementById('activity-timeline');
        setWidthElement(timelineEle ? `calc(${timelineEle.offsetWidth}px - 90px)` : `calc(${attListItem?.offsetWidth ? `${attListItem?.offsetWidth}px` : '100vw'} - 110px)`);
    };

    useEffect(() => {
        getWidth();
        const handleResize = () => getWidth();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [splitScreen?.enabled]);

    return (
        <div
            style={{
                border: 'solid 1px #494b4c',
                borderRadius: 4,
                width: widthElement,
                padding: 6,
                color: theme.palette.mode !== 'light' ? '#FFFFFF' : '#333333',
                minHeight: 45,
                display: 'flex',
                alignItems: 'center',
                marginTop: -5,
            }}
        >
            {props.children}
        </div>
    );
};

export default RowContainer;